import styled from 'styled-components';

export const SubTitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.rule.greyLight};
  text-align: center;
  font-weight: normal;
`;
